/** @format */

import ChevronRightActive from '@/assets/icons/joivy_icon_chevron_right_dark.svg';
import ChevronRight from '@/assets/icons/joivy_icon_chevron_right_light.svg';
import CloseIcon from '@/assets/icons/joivy_icon_close.svg';
import { TTranslation } from '@/i18n/createProvider';
import { useAppTranslation } from '@/i18n/declarations';
import { useAppDispatch } from '@/redux/hooks';
import React, { FunctionComponent as FC, useState } from 'react';
import { CITIES } from '../../../@ducks/locations/constants';
import { CitiesToRender } from './CitiesToRender';
import type { CountryCode } from './Content.constants';
import { CITIES_TO_COUNTRY } from './Content.constants';
import { CitiesList, CountriesList, CountryItem, MobileHeader, MobileSticky } from './index.style';
import { ContentProps } from './types';

const countries: readonly CountryCode[] = ['it', 'fr', 'es', 'pt'] as const;

export const Content: FC<ContentProps> = ({ mobile = false, closeDropdown, selectedCity }) => {
  const dispatch = useAppDispatch();
  const [activeCountry, setActiveCountry] = useState<CountryCode>(CITIES_TO_COUNTRY.get(selectedCity) ?? countries[0]);
  const { t } = useAppTranslation();

  const citiesPerCountry = (country: CountryCode) => CITIES.filter(city => city.country === country).length;

  const gridRows = mobile ? undefined : Math.ceil(Math.max(...countries.map(country => citiesPerCountry(country))) / 2);

  const onClickCountry = (country: CountryCode) => {
    if (country !== activeCountry) dispatch({ type: 'LISTING_RESET_FILTERS' });
    setActiveCountry(country);
  };

  return (
    <>
      <MobileSticky>
        <MobileHeader>
          <p>{t('select_city')}</p>
          <button className="close" onClick={closeDropdown}>
            <img src={CloseIcon} alt="close" width={14.4} />
          </button>
        </MobileHeader>
        <CountriesList>
          {countries.map(country => (
            <CountryItem onClick={() => onClickCountry(country)} key={country} $active={country === activeCountry}>
              <button>
                <span>
                  {t(`menu_living_${country}` as TTranslation)}{' '}
                  <span className="number">({citiesPerCountry(country)})</span>
                </span>
                <img src={country === activeCountry ? ChevronRightActive : ChevronRight} alt="open" width={24} />
              </button>
            </CountryItem>
          ))}
        </CountriesList>
      </MobileSticky>
      <CitiesList $rows={gridRows}>
        <CitiesToRender activeCountry={activeCountry} closeDropdown={closeDropdown} />
      </CitiesList>
    </>
  );
};
